import { graphql, Link, StaticQuery } from "gatsby";
import React from "react";
import styled from "styled-components";

const FOOTER_SLUGS = graphql`
  {
    allWordpressWpApiMenusMenusItems(filter: { name: { regex: "/Footer/" } }) {
      edges {
        node {
          items {
            title
            object_slug
          }
        }
      }
    }
  }
`;

const FooterWrapper = styled.div`
  height: 50px;
  padding-bottom: 20px;
  font-family: "Questrial", sans-serif;
  margin-top: 40px;
  font-size: 14px;
`;

const FootRule = styled.hr`
  width: 90%;
  margin-bottom: 12px;
`;

const FooterLinksWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: auto;
  height: 25px;
`;

const FooterLink = styled(Link)`
  color: #24272a;
  transition: all 200ms ease-out;
  animation: fade 0.2s ease-out;
  animation-direction: reverse;
  padding-left: 5px;
  padding-right: 5px;
  font-size: 12px;
  @media (min-width: 325px) and (min-height: 500px) {
    padding-left: 15px;
    padding-right: 15px;
    font-size: 14px;
  }
  text-decoration: none;
  &:hover {
    color: #dd8a5f;
    animation: fade 0.2s ease-out;
    font-size: 15px;
  }

  @keyframes fade {
    0% {
      font-size: 14px;
    }

    100% {
      font-size: 15px;
    }
  }
`;

const Copyright = styled.div`
  margin-top: 5px;
  text-align: center;
  font-size: 11px;
`;

function Footer() {
  return (
    <FooterWrapper>
      <FootRule />
      <StaticQuery
        query={FOOTER_SLUGS}
        render={(props) => (
          <FooterLinksWrapper>
            {props.allWordpressWpApiMenusMenusItems.edges[0].node.items.map(
              (footerItem) => (
                <FooterLink to={`../${footerItem.object_slug}`}>
                  <div dangerouslySetInnerHTML={{ __html: footerItem.title }} />
                </FooterLink>
              )
            )}
          </FooterLinksWrapper>
        )}
      />
      <Copyright>
        © {new Date().getFullYear()} GrimsbyAndCleethorpesMuseum.com
      </Copyright>
    </FooterWrapper>
  );
}
export default Footer;
